import React from "react";
import { compose, withStateHandlers, withHandlers } from "recompose";
import { FormGroup } from "components/common";
import { Button, PopoverBody, Popover, DropdownItem } from "reactstrap";
import download from "downloadjs";
import Dropzone from "react-dropzone";
import { withXeroErrors } from "components";
import { Trans } from "react-i18next";

export const Attachments = ({
  attachments,
  isOpen,
  toggle,
  handleDownload,
  pending,
  handleDropAccepted,
  includeOnline,
  handleIncludeOnlineChanged,
  hideIncludeOnline,
  XeroErrors,
  className,
}) => ( 
  <div>
    <Button className={`${className || ''} mx-1`} size="sm" color="primary" id="attachments-popover" onClick={toggle}>
      <span className="fa fa-file" />
      {attachments.length > 0 ? (
        <span className="ml-1"><Trans>Files</Trans></span>
      ) : (
        <span className="ml-1"><Trans>Attach Files</Trans></span>
      )}
      {!!attachments.length && <span> ({attachments.length}) </span>}
    </Button>
    <div>
      <Popover
        placement="right"
        className="attachments-popover"
        target="attachments-popover"
        isOpen={isOpen}
        toggle={toggle}
        style={{ maxWidth: "auto", overflow: "auto"}}
      >
        <PopoverBody>
          <XeroErrors />
          <div className="text-center">
            {pending && <span className="fa fa-spin fa-spinner" />}
          </div>
          {attachments.map((i) => (
            <div
              className="d-flex justify-content-between my-1"
              key={i.AttachmentID}
            >
              <div className="text-nowrap">
                  <DropdownItem
                    style={{ whiteSpace: 'normal' }}
                    disabled={pending}
                    onClick={() => handleDownload(i)}
                  >{i.FileName}
                  </DropdownItem>
                {i.IncludeOnline && (
                  <span className="text-muted small">
                    <Trans>Included with invoice</Trans>
                  </span>
                )}
              </div>
              {/*<UncontrolledButtonDropdown>
                <DropdownToggle caret color="success" className="btn-sm">
                  <span className="fa fa-cog text-muted" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    disabled={pending}
                    onClick={() => handleDownload(i)}
                  >
                    <Trans>Download</Trans>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>*/}
            </div>
          ))}
          <hr />
          {attachments.length < 10 ? (
            <div className="d-flex align-items-center">
              <Dropzone
                multiple={false}
                disablePreview={true}
                disabled={pending}
                style={{ cursor: "pointer" }}
                onDropAccepted={handleDropAccepted}
                className="btn-sm btn btn-primary"
              >
                <span className="fa fa-plus mx-1" />{" "}
                <Trans>Upload file...</Trans>
              </Dropzone>
              <div className="mx-2" />
              {!hideIncludeOnline && (
                <FormGroup check label="Incl. with Inv">
                  <input
                    type="checkbox"
                    onChange={handleIncludeOnlineChanged}
                    value={includeOnline}
                  />
                </FormGroup>
              )}
            </div>
          ) : (
            <Trans>Maximum number of files reached</Trans>
          )}
        </PopoverBody>
      </Popover>
    </div>
  </div>
);

export const enhance = compose(
  withStateHandlers(
    {
      isOpen: false,
      includeOnline: false,
    },
    {
      handleIncludeOnlineChanged: () => (e) => ({
        includeOnline: e.target.checked,
      }),
      setPending: () => (pending) => ({ pending }),
      toggle:
        ({ isOpen }) =>
        () => ({ isOpen: !isOpen }),
    }
  ),
  withXeroErrors(),
  withHandlers({
    handleDropAccepted:
      ({
        setPending,
        xero,
        baseUrl,
        onAttachmentsChanged,
        includeOnline,
        setXeroErrors,
      }) =>
      ([file]) => {
        setPending(true);
        setXeroErrors(null);

        const reader = new FileReader();
        reader.onload = (e) => {
          xero
            .post(
              `${baseUrl}/attachments`,
              {
                filename: file.name,
                content: e.target.result,
              },
              {
                params: {
                  appParams: {
                    include_online: includeOnline,
                  },
                },
              }
            )
            .get("data")
            .get("Attachments")
            .then((data) => {
              onAttachmentsChanged && onAttachmentsChanged(data);
            }, setXeroErrors)
            .finally(() => {
              setPending(false);
            });
        };
        reader.readAsDataURL(file);
      },
    handleDownload:
      ({ xero, baseUrl, setPending }) =>
      (attachment) => {
        setPending(true);
        xero
          .get(
            `${baseUrl}/attachments/${attachment.FileName}?mimetype=${attachment.MimeType}`
          )
          .get("data")
          .tap((data) => {
            download(data.content.replace(/\s/g, ""), data.filename);
          })
          .finally(() => setPending(false));
      },
  })
);

export default enhance(Attachments);
